module.exports = __webpack_public_path__ + "static/mbank-dde4bb09a83afc3f4dcedee8ef35bc5d.png";